import { render, staticRenderFns } from "./GpsAlarmList.vue?vue&type=template&id=59a81054&scoped=true&"
import script from "./GpsAlarmList.vue?vue&type=script&lang=js&"
export * from "./GpsAlarmList.vue?vue&type=script&lang=js&"
import style0 from "./GpsAlarmList.vue?vue&type=style&index=0&id=59a81054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a81054",
  null
  
)

export default component.exports